exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".password-form-row{margin-bottom:1rem}.required-text{font-size:12px}@media(max-width: 576px){#edit-profile-modal .col-11{flex:0 0 100%;max-width:100%;margin-left:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/forms/AccountFormPanel/AccountFormPanel.scss
// module id = 769
// module chunks = 0